export function clearCloak () {

  let elems = document.querySelectorAll('.cloak');
  [].forEach.call(elems, function(el) {
      el.classList.remove('cloak');
  });

}

export function scrollToEl ( element, to, duration ) {
  if (duration < 0) return;
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollToEl(element, to, duration - 10);
  }, 10);
}